export const GET_SINGLE_QUIZ_REQUEST = "GET_SINGLE_QUIZ_REQUEST";
export const GET_SINGLE_QUIZ_SUCCESS = "GET_SINGLE_QUIZ_SUCCESS";
export const GET_SINGLE_QUIZ_FAILURE = "GET_SINGLE_QUIZ_FAILURE";

export const GET_QUIZ_DETAILS_REQUEST = "GET_QUIZ_DETAILS_REQUEST";
export const GET_QUIZ_DETAILS_SUCCESS = "GET_QUIZ_DETAILS_SUCCESS";
export const GET_QUIZ_DETAILS_FAILURE = "GET_QUIZ_DETAILS_FAILURE";
export const RESET_QUIZ_DETAILS = "RESET_QUIZ_DETAILS";
